import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    maps: null,
    map: {},
  },
  mutations: {
    maps(state, payload) {
      state.maps = payload;
    },
    map(state, payload) {
      state.map = payload;
    },
  },
  actions: {
    maps({ commit, state }) {
      return new Promise((resolve, reject) => {
        if (state.maps) {
          resolve();
        } else {
          fetch('https://api.tracker.pilviotus.fi/maps')
            .then(response => response.json())
            .then((json) => {
              commit('maps', json);
              resolve();
            })
            .catch((/* err */) => {
              commit('maps', null);
              reject();
            });
        }
      });
    },
    map({ commit }, id) {
      return new Promise((resolve, reject) => {
        fetch(`https://api.tracker.pilviotus.fi/maps/${id}`)
          .then(response => response.json())
          .then((json) => {
            commit('map', json);
            resolve();
          })
          .catch((/* err */) => {
            commit('map', null);
            reject();
          });
      });
    },
  },
  getters: {
    // eslint-disable-next-line arrow-body-style
    getMap: (state) => {
      return id => state.maps.find(map => map.map === id);
    },
  },
});

export { store as default };
